// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SMGF9","header":"styles_header__b-NUE"};